//settings
if ($('.center').slick) {
  $(document).on('ready', function () {
    $('.center').slick({
      dots: true,
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchThreshold: 1000,
      //   autoplay: true,
      arrows: false,
      slide: '.services__item',
    });
  });
}
